import RichText from "@/components/RichText";

// "Collage" n'a pas de props propres au-delà du titre — son contenu vient
// entièrement de blocs génériques "image_block" (theme_service.GENERIC_BLOCK_TYPES),
// ajoutés/réordonnés depuis le panneau de droite comme n'importe quel autre
// bloc (voir BlockList.jsx). Une section sans image n'affiche rien plutôt
// qu'une grille vide.
export default function CollageSection({ props = {}, blocks = [] }) {
  const heading = props.heading || "";
  const images = (blocks || []).filter((b) => b.enabled !== false && b.type === "image_block");

  if (!images.length) return null;

  return (
    <section className="max-w-[1240px] mx-auto px-6 md:px-10 py-section md:py-section-md">
      {heading && (
        <RichText
          as="h2"
          className="font-display font-semibold text-[28px] md:text-[32px] leading-tight tracking-[-0.02em] text-ink mb-8"
          html={heading}
        />
      )}
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {images.map((block) => (
          <div
            key={block.id}
            data-block-key={block.id}
            className="rounded-2xl overflow-hidden bg-sand aspect-square"
          >
            {block.props?.image_url && (
              <img src={block.props.image_url} alt={block.props?.alt || ""} className="w-full h-full object-cover" />
            )}
          </div>
        ))}
      </div>
    </section>
  );
}
